import { Observable, of, pipe, throwError } from 'rxjs';
import { map, retry, catchError } from 'rxjs/operators';

const formatDate = (value) => {
  const date = new Date(value);
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

export const resultPipe = (results: Observable<any>) => results.pipe(

  // retry the http call three times:
  retry(3),

  // check for required property:
  map(data => {
    if (data.results === undefined) {
      throw new Error('missing the results property');
    } else {
      return data;
    }
  }),

  // check for trecordTotalQuantityotal property:
  map(data => {
    if (data.recordTotalQuantity === undefined) {
      throw new Error('missing the recordTotalQuantity property');
    } else {
      return data;
    }
  }),

  // check for aggregationData property:
  map(data => {
    if (data.aggregationData === undefined) {
      throw new Error('missing the aggregationData property');
    } else {
      return data;
    }
  }),

  // filter out empty facets:
  map(data => {
    const _aggregationData = {};

    Object.keys(data.aggregationData).forEach(key => {
      if (data.aggregationData[key].length > 0) {
        _aggregationData[key] = data.aggregationData[key];
      }
    });

    data.aggregationData = _aggregationData;
    return data;
  }),

  map((data: any) => {
    data.results = data.results.map((item: any, index: number) => {
      item.id = index; return item;
    });
    return data;
  }),

  // handle errors:
  catchError(err => {
    return throwError(err.message);
  })

);

export const documentsPipe = (results: Observable<any>) => results.pipe(
  map(data => { 
    return data;
  }),
  // handle errors:
  catchError(err => {
    return throwError(err.message);
  })
);

export const decisionsPipe = (results: Observable<any>) => results.pipe(
  map(data => {
    data.results = data.results.map((item) => {
      const row: any = item;
      return row;
    });
    return data;
  })
);

export const proceedingsPipe = (results: Observable<any>) => results.pipe(
  map(data => {
    data.results = data.results.map((item) => {
      const row: any = item;
      return row;
    });
    return data;
  })
);
